import Header from "./componentes/Header";
import Hero from "./componentes/Hero";
import Services from "./componentes/Service";
import CTASection from "./componentes/CTASection";
import Footer from "./componentes/Footer";
import Portfolio from "./componentes/Portifolio";
import './App.css';
import WhatsAppButton from "./componentes/WhatsAppButton";

function App() {
  return (
    <>
      
        
        <Header />
        <Hero />
        <Services />
        <Portfolio />
        <CTASection />
        <Footer />

        <WhatsAppButton/>
      
    </>
  );
}

export default App;

